import { render, staticRenderFns } from "./GlobalConfirmationDialog.vue?vue&type=template&id=8e622bce&scoped=true&"
import script from "./GlobalConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./GlobalConfirmationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalConfirmationDialog.vue?vue&type=style&index=0&id=8e622bce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e622bce",
  null
  
)

export default component.exports